import { Card, Skeleton } from 'antd'
import SkeletonButton from 'antd/lib/skeleton/Button'
import React from 'react'

function CardSkeleton() {
  return (
    <Card
        bodyStyle={{paddingInline: "14px"}}
        cover={<SkeletonButton className='searchSkeletonButton' style={{width: "100%"}} active/>}
    >
        <Skeleton 
            active={true}
            paragraph={true}
            title={false}
        />
    </Card>
  )
}

export default CardSkeleton